package games.polyclub.website.frontend.store.layout

import games.polyclub.frontend.lib.messagerenderer.MessageRendererMode
import games.polyclub.frontend.lib.messagerenderer.m
import games.polyclub.frontend.lib.react.simplified.SFC
import games.polyclub.frontend.lib.react.simplified.tags.div
import games.polyclub.frontend.lib.react.simplified.tags.h1
import games.polyclub.frontend.lib.react.simplified.tags.li
import games.polyclub.frontend.lib.react.simplified.tags.ol
import games.polyclub.frontend.lib.react.utils.classSet
import games.polyclub.message.Message
import games.polyclub.website.frontend.store.context.useBreadcrumbs
import games.polyclub.website.frontend.store.sitemap.Icon
import react.PropsWithChildren
import react.router.dom.Link

external interface PageHeaderProps: PropsWithChildren {
    var titleIcon: Icon?
    var title: Message?
}

val PageHeader = SFC<PageHeaderProps> { props ->
    val breadcrumbs = useBreadcrumbs()
    div("content-header") {
        div("content-fluid") {
            div("row mb-2") {
                props.title?.let { title ->
                    div("col-sm-6") {
                        h1("m-0") {
                            props.titleIcon?.let { icon ->
                                with(icon) {
                                    renderIcon()
                                }
                                +" "
                            }
                            m(title, MessageRendererMode.RAW)
                        }
                    }
                    div("col-sm-6") {
                        ol("breadcrumb float-sm-right") {
                            val entries = breadcrumbs.names
                            entries.forEachIndexed { index, (path, title) ->
                                li("breadcrumb-item") {
                                    if (index == entries.lastIndex) {
                                        classSet += "active"
                                        m(title, MessageRendererMode.RAW)
                                    } else {
                                        Link {
                                            to = path
                                            m(title, MessageRendererMode.RAW)
                                        }
                                    }
                                }
                            }
                        }
                    }
                    +props.children
                }
            }
        }
    }
}
